import api from '../common/helpers/apiHelper';
import { ISurvey } from '../common/models/survey/ISurvey';
import { IListData } from '../common/models/common/IListData';
import { IFilter } from '../common/models/filter/IFilter';
import { mapSortToSortReq, mapFilterToFilterReq } from '../common/helpers/filterHelper';
import { ISurveyData } from '../common/models/survey/ISurveyData';
import { IFavoriteSurvey } from '../common/models/survey/IFavoriteSurvey';
import { ICreateSurvey } from '../common/models/survey/ICreateSurvey';
import { IUpdateSurvey } from '../common/models/survey/IUpdateSurvey';
import { ISurveyQuestion } from '../common/models/survey/ISurveyQuestion';
import { INameData } from '../common/models/common/INameData';

export const getSurveys = (payload: IFilter) => api.get<IListData<ISurvey>>(
  '/api/surveys/',
  { ...payload, sort: mapSortToSortReq(payload.sort), filter: mapFilterToFilterReq(payload.filter) }
);

export const getRefReqSurveys = (payload: IFilter) => api.get<IListData<ISurvey>>(
  '/api/surveys/ref-request',
  { ...payload, sort: mapSortToSortReq(payload.sort), filter: mapFilterToFilterReq(payload.filter) }
);

export const getSurveyById = (payload: string) => api.get<ISurveyData>(`/api/surveys/${payload}`);

export const markAsFavorite = ({ id, isFavorite }: IFavoriteSurvey) => (
  api.put(`/api/surveys/${id}/favorite`, { isFavorite })
);

export const checkSurveyName = (payload: { name: string; id?: string }) => api.get<{ isNameTaken: boolean }>(
  '/api/surveys/name',
  payload
);

export const createSurvey = (payload: ICreateSurvey) => api.post<ISurveyData>(
  '/api/surveys',
  payload
);

export const updateSurvey = (payload: IUpdateSurvey) => api.put<ISurveyData>(
  `/api/surveys/${payload.id}`,
  payload
);

export const getDefaultQuestions = () => api.get<ISurveyQuestion[]>(
  '/api/surveys/default'
);

export const getSurveyNames = () => api.get<INameData[]>('/api/surveys/names');
